<template>
  <div>
    <Rewards :selectedPageTemplate="selectedPageTemplate"/>
  </div>
</template>

<script>
  export default {
    components: {
      Rewards: () => import('@/components/Design/View/ViewTheme'),
    },
    computed: {
    },
    data: () => ({
      selectedPageTemplate: 'Rewards',
    }),
    created () {
    }
  }
</script>
